module.exports = __webpack_public_path__ + "img/culture2.2fa914af.jpg";